import React from 'react';

// Sticky under the site header. `top` matches the header height so it pins directly beneath it.
const AccTabBar = ({ tabs, active, onChange }) => (
    <div className="lp-acc-tabbar-wrap">
        <div className="lp-acc-wrap">
            <div className="lp-acc-tabbar" role="tablist">
                {tabs.map(t => (
                    <button
                        key={t.id}
                        type="button"
                        role="tab"
                        aria-selected={active === t.id}
                        className={`lp-acc-tab${active === t.id ? ' is-active' : ''}`}
                        onClick={() => onChange(t.id)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
        </div>
    </div>
);

export default AccTabBar;
